// src/components/layout/PageContainer.jsx
import React from 'react';
import { cn } from '@/lib/utils';

export default function PageContainer({ 
  children, 
  maxWidth = 'max-w-7xl',
  className 
}) {
  return (
    <main className="flex-1 overflow-y-auto bg-[#0a0a0a] scrollbar-thin">
      <div className={cn(
        'mx-auto px-8 py-6',
        maxWidth,
        className
      )}>
        {children}
      </div>
    </main>
  );
}